import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as CanvasJSAngularChart from 'src/assets/canvasjs.angular.component';
import { VisitorBreakdownComponent } from './components/visitor-breakdown/visitor-breakdown.component';
import { VisitorCategoriesComponent } from './components/visitor-categories/visitor-categories.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { VisitorSummaryComponent } from './components/visitor-summary/visitor-summary.component';
import { IncidentBreakdownComponent } from './components/incident-breakdown/incident-breakdown.component';
import { IncidentCategoriesComponent } from './components/incident-categories/incident-categories.component';
import { VisitorInOutBoundComponent } from './components/visitor-in-out-bound/visitor-in-out-bound.component';
import { IncidentRiskProfileComponent } from './components/incident-risk-profile/incident-risk-profile.component';
import { RiskBarGraphComponent } from './components/risk-bar-graph/risk-bar-graph.component';
import { RiskLineGraphComponent } from './components/risk-line-graph/risk-line-graph.component';
import { RiskPieGraphComponent } from './components/risk-pie-graph/risk-pie-graph.component';
import { IncidentTimlineGraphComponent } from './components/incident-timline-graph/incident-timline-graph.component';
import { MaterialModule } from 'src/app/shared/modules/material.module';
import { VisitorBarGraphComponent } from './components/visitor-bar-graph/visitor-bar-graph.component';
import { IncidentHeatMapComponent } from './components/incident-heat-map/incident-heat-map.component';
import { SmoothLineChartComponent } from './components/smooth-line-chart/smooth-line-chart.component';
import {
  GoogleMap,
  MapHeatmapLayer,
  MapInfoWindow,
} from '@angular/google-maps';
import { RiskBreakdownGraphComponent } from './components/risk-breakdown-graph/risk-breakdown-graph.component';
import { VisitorTimelineGraphComponent } from './components/visitor-timeline-graph/visitor-timeline-graph.component';
import { IncidentStatusGraphComponent } from './components/incident-status-graph/incident-status-graph.component';
import { VisitorCategoryPieComponent } from './components/visitor-category-pie/visitor-category-pie.component';
import { IncidentTimelineSerialGraphComponent } from './components/incident-timeline-serial-graph/incident-timeline-serial-graph.component';
var CanvasJSChart = CanvasJSAngularChart.CanvasJSChart;
const components = [
  CanvasJSChart,
  VisitorBreakdownComponent,
  VisitorCategoriesComponent,
  VisitorSummaryComponent,
  IncidentBreakdownComponent,
  IncidentCategoriesComponent,
  VisitorInOutBoundComponent,
  IncidentRiskProfileComponent,
  RiskBarGraphComponent,
  RiskLineGraphComponent,
  RiskPieGraphComponent,
  IncidentTimlineGraphComponent,
  VisitorBarGraphComponent,
  IncidentHeatMapComponent,
  SmoothLineChartComponent,
  RiskBreakdownGraphComponent,
  VisitorTimelineGraphComponent,
  IncidentStatusGraphComponent,
  VisitorCategoryPieComponent,
  IncidentTimelineSerialGraphComponent,
];
@NgModule({
  declarations: [...components],
  imports: [
    CommonModule,
    MaterialModule,
    GoogleMap,
    MapHeatmapLayer,
    MapInfoWindow,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
  ],
  exports: [CommonModule, ...components],
  bootstrap: [IncidentHeatMapComponent],
})
export class ChartsModule {}
